const styles = () => ({
  root: {
    textAlign: 'center',

    '& svg': {
      display: 'inline',
      marginBottom: '10px',
    },
  },

  emptySearchHeadline: {
    fontSize: '14px',
    color: '#596168',
    fontWeight: 500,
  },

  searchQuery: {
    fontWeight: 600,
  },
});

export default styles;
